<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Poderi Aldo Conterno</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Poderi Aldo Conterno è, secondo James Suckling, “una delle tenute vinicole più impressionanti di tutta Italia, forse del mondo”, e infatti, il Granbussia 2008 è stato il suo vino italiano dell'anno nel 2016. Matt Kramer di Wine Lo spettatore ha definito Aldo Conterno “il più grande del Barolo
                        vignaiolo”. Robert Parker ha persino portato una bottiglia di Barolo Bussia 1989 dalla sua cantina privata
                        per la sua serata “Bring Your Own Bottle”. Il soprannome di Aldo Conterno è “King Of Barolo”. Tutto molto
                        elogio davvero, ma è giustificato?
                    </div>

                    <div class="howto-title2">Classificato come uno dei principali produttori piemontesi</div>
                    <div class="howto-text">
                        Il nome Conterno si intreccia indissolubilmente nel tessuto dell'agro del Barolo da sempre
                        molte cinque generazioni. Figlio del compianto, grande Giacomo Conterno, Aldo aveva grandi scarpe da riempire quando
                        decide di aprire la propria attività nel 1969. Puntando gli occhi sulla cantina “Il Favot” del 1750
                        nel paese di Monforte d'Alba, Aldo ha acquisito 25 ettari di vigneto di prima qualità, perfetto per
                        Nebbiolo. Trasformando i pacchi in un'agricoltura sostenibile, ha conservato i processi tradizionali
                        ma ha introdotto un'innovazione "radicale" (all'epoca), come un minor tempo di fermentazione per
                        ridurre i tannini così caratteristici del Barolo. Potrebbe essere qui che si è guadagnato il soprannome.
                        Aldo è morto nel 2012 e oggi i suoi tre figli Franco, Stefano e Giacomo conducono la scena, mescolandosi
                        l'intrinseco rispetto alla tradizionalità con le moderne tecniche che solo gli italiani sembrano avere
                        sapere come fare.
                    </div>

                    <div class="howto-title2">Lode più che giustificata</div>
                    <div class="howto-text">
                        Il vertice del portfolio di Conterno è senza dubbio il Barolo Granbussia, sopra citato.
                        Prodotto solo in annate eccezionali (solo otto annate tra il 1971 e il 1994), Granbussia è
                        una miscela di vino proveniente dai tre appezzamenti di vigneto. Tipicamente la miscela è composta dal 70% di Romirasco,
                        15% Cicala e 15% Colonello ed è così popolare che nelle rare occasioni che la vigna
                        annuncia la produzione, le assegnazioni obbligazionarie si estinguono ben prima del Vinitaly, l'internazionale
                        fiera dove le allocazioni sono tradizionalmente distribuite. L'ultima annata ad essere rilasciata è stata
                        2009 (250 casse), con bottiglie scambiate per circa € 500 nel secondo trimestre 2019, in aumento rispetto al rilascio
                        prezzo di € 390 12 mesi prima.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Poderi Aldo Conterno</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Poderi Aldo Conterno ist laut James Suckling „eines der beeindruckendsten Weingüter in ganz Italien, vielleicht sogar weltweit“, und tatsächlich war der Granbussia 2008 sein italienischer Wein des Jahres 2016. Matt Kramer von Wine Zuschauer bezeichneten Aldo Conterno als „Barolos Größten.“
                        Winzer.“ Robert Parker brachte sogar eine Flasche Barolo Bussia 1989 aus seinem Privatkeller mit
                        für seinen „Bring Your Own Bottle“-Abend. Aldo Conternos Spitzname ist „King Of Barolo“. Alles sehr
                        Großes Lob, aber ist es gerechtfertigt?
                    </div>

                    <div class="howto-title2">Als einer der führenden Produzenten im Piemont eingestuft</div>
                    <div class="howto-text">
                        Der Name Conterno ist seit jeher untrennbar mit dem Gefüge der Barolo-Landschaft verbunden
                        viele fünf Generationen. Als Sohn des verstorbenen großen Giacomo Conterno trat Aldo in große Fußstapfen
                        1969 beschloss er, seinen eigenen Betrieb zu eröffnen. Sein Ziel war das Weingut „Il Favot“ aus dem Jahr 1750
                        Im Dorf Monforte d’Alba erwarb Aldo 25 Hektar erstklassigen Weinbergs, perfekt für
                        Nebbiolo. Indem er die Parzellen in nachhaltige Landwirtschaft überführte, bewahrte er traditionelle Prozesse
                        führte jedoch (damals) „radikale“ Innovationen ein, beispielsweise eine kürzere Fermentationszeit, um dies zu erreichen
                        reduzieren die für Barolo so charakteristischen Tannine. Möglicherweise hat er sich daher seinen Spitznamen verdient.
                        Aldo starb im Jahr 2012 und heute leiten seine drei Söhne Franco, Stefano und Giacomo die Show und vermischen sich
                        der inhärente Respekt vor der Tradition mit modernen Techniken, den nur die Italiener zu haben scheinen
                        wissen, wie es geht.
                    </div>

                    <div class="howto-title2">Lob, das mehr als gerechtfertigt ist</div>
                    <div class="howto-text">
                        Der Höhepunkt im Portfolio von Conterno ist zweifellos der oben erwähnte Barolo Granbussia.
                        Granbussia wird nur in außergewöhnlichen Jahrgängen hergestellt (nur acht Jahrgänge zwischen 1971 und 1994).
                        eine Mischung aus Weinen aus den drei Weinbergparzellen. Typischerweise besteht die Mischung aus 70 % Romirasco,
                        Er besteht zu 15 % aus Cicala und zu 15 % aus Colonello und ist so beliebt, dass er nur bei seltenen Gelegenheiten im Weinberg serviert wird
                        kündigt die Produktion an, die Anleihenzuteilungen werden lange vor Vinitaly, dem Internationalen, eingestellt
                        Messe, auf der traditionell Kontingente vergeben werden. Der letzte Jahrgang, der veröffentlicht wurde, war
                        2009 (250 Kisten), wobei die Flaschen im zweiten Quartal 2019 im Vergleich zur Veröffentlichung für etwa 500 € gehandelt wurden
                        Preis von 390 € vor 12 Monaten.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Poderi Aldo Conterno</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Poderi Aldo Conterno est, selon James Suckling, "l'un des domaines viticoles les plus impressionnants de toute l'Italie, peut-être du monde", et en fait, le Granbussia 2008 a été son vin italien de l'année en 2016. Matt Kramer de Wine Le spectateur a appelé Aldo Conterno "le plus grand de Barolo
                        vigneron. » Robert Parker a même apporté une bouteille de Barolo Bussia 1989 de sa cave privée
                        pour sa soirée « Apportez votre propre bouteille ». Le surnom d'Aldo Conterno est "King Of Barolo". Tout très
                        des éloges en effet, mais est-ce justifié?
                    </div>

                    <div class="howto-title2">Classé comme l'un des principaux producteurs du Piémont</div>
                    <div class="howto-text">
                        Le nom de Conterno est inséparablement lié au tissu de la campagne de Barolo depuis
                        plusieurs cinq générations. Fils de feu le grand Giacomo Conterno, Aldo avait de gros souliers à chausser quand
                        il décide d'ouvrir sa propre exploitation en 1969. Jetant son dévolu sur la cave « Il Favot » de 1750
                        dans le village de Monforte d'Alba, Aldo a acquis 25 hectares de vignobles de premier ordre, parfaits pour
                        Nebbiolo. Passant les parcelles à l'agriculture raisonnée, il a conservé les procédés traditionnels
                        mais a introduit une innovation "radicale" (à l'époque), comme moins de temps de fermentation afin de
                        alléger les tanins si caractéristiques du Barolo. C'est peut-être là qu'il a gagné son surnom.
                        Aldo est décédé en 2012 et aujourd'hui ses trois fils Franco, Stefano et Giacomo dirigent le spectacle, mélangeant
                        le respect inhérent à la tradition avec des techniques modernes que seuls les Italiens semblent
                        savoir faire.
                    </div>

                    <div class="howto-title2">Des éloges plus que justifiés</div>
                    <div class="howto-text">
                        Le sommet du portefeuille de Conterno est sans aucun doute le Barolo Granbussia, mentionné ci-dessus.
                        Produit uniquement dans des millésimes exceptionnels (seulement huit millésimes entre 1971 et 1994), Granbussia est
                        un assemblage des vins des trois parcelles de vignes. Généralement, le mélange est composé de 70% de Romirasco,
                        15% Cicala et 15% Colonello et est si populaire que dans les rares occasions où le vignoble
                        annonce la production, les allocations obligataires sont éteintes bien avant Vinitaly, l'international
                        foire commerciale où les dotations sont traditionnellement distribuées. Le dernier millésime sorti était
                        2009 (250 caisses), avec des bouteilles s'échangeant autour de 500 € au T2 2019, en hausse par rapport à la sortie
                        prix de 390 € 12 mois auparavant.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Poderi Aldo Conterno</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Poderi Aldo Conterno is, according to James Suckling, “one of the most impressive wine estates in all of Italy, perhaps in the world”, and in fact, the Granbussia 2008 was his Italian Wine of the Year in 2016. Matt Kramer of Wine Spectator called Aldo Conterno “Barolo's greatest
                        winemaker.” Robert Parker even brought a bottle of Barolo Bussia 1989 from his private cellar
                        for his “Bring Your Own Bottle” night. Aldo Conterno’s nickname is “King Of Barolo”. All very
                        high praise indeed, but is it warranted?
                    </div>

                    <div class="howto-title2">Ranked as one of Piedmont's foremost producers</div>
                    <div class="howto-text">
                        The Conterno name has been inseparably intertwined into the fabric of the Barolo countryside for
                        many five generations. Son of the late, great Giacomo Conterno, Aldo had big shoes to fill when
                        he decided to open his own operation in 1969. Setting his sights on the 1750 “Il Favot” winery
                        in the village Monforte d’Alba, Aldo acquired 25 hectares of prime vineyard, perfect for
                        Nebbiolo. Turning the parcels over to sustainable farming, he conserved traditional processes
                        but introduced “radical” (at the time) innovation, such as less fermentation time in order to
                        reduce the tannins so characteristic of Barolo. This may well be where he earned his nickname.
                        Aldo died in 2012 and today his three sons Franco, Stefano and Giacomo run the show, blending
                        the inherent respect to traditionality with modern techniques that only the Italians seem to
                        know how to do.
                    </div>

                    <div class="howto-title2">Praise that is more than warranted</div>
                    <div class="howto-text">
                        The summit of Conterno’s portfolio is undoubtedly the Barolo Granbussia, mentioned above.
                        Produced only in exceptional vintages (just eight vintages between 1971 and 1994), Granbussia is
                        a blend of wine from the three vineyard plots. Typically the blend is made from 70% Romirasco,
                        15% Cicala and 15% Colonello and is so popular that on the rare occasions that the vineyard
                        announces production, bond allocations are extinguished well before Vinitaly, the international
                        trade fair where allocations are traditionally given out. The last vintage to be released was
                        2009 (250 cases), with bottles trading for approximately €500 in Q2 2019, up from the release
                        price of €390 12-months previously.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PoderiAldoConterno",
    head: {
        title: 'Poderi Aldo Conterno | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional Piedmont wine at Poderi Aldo Conterno, a renowned wine producer known for its tradition, innovation and excellence in winemaking. Experience the unique blend of old world and new world techniques in their wines and take a sip of their timeless Piedmont beauty.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {
                    report: 'Giuseppe Mascarello e Figlio',
                    src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
                },
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
